import { NgModule } from '@angular/core';
import { SearchHighlightPipe } from './search-highlight.pipe';

/**
 * A module containing objects associated with the search highlight pipe
 */

export class SearchHighlightPipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SearchHighlightPipe
  ],
  exports: [
    SearchHighlightPipe
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
